export interface EventMap {
  'auth:change': { isLoggedIn: boolean };
  'slide-out:toggle': { open: boolean };
  'side-nav:expand': { expanded: boolean };
  'search:focus': void;
  'user-menu:toggle': { open: boolean };
  'notifications:open': void;
  'notifications:close': void;
  'analytics:click': { label: string };
}

export class EventBus {
  private target = new EventTarget();

  emit<K extends keyof EventMap>(name: K, detail?: EventMap[K]): void {
    this.target.dispatchEvent(new CustomEvent(name, { detail }));
  }

  on<K extends keyof EventMap>(name: K, cb: (detail: EventMap[K]) => void): () => void {
    const handler = (e: Event) => cb((e as CustomEvent).detail);
    this.target.addEventListener(name, handler);
    return () => this.target.removeEventListener(name, handler);
  }
}
